/* eslint-disable camelcase */
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { DefaultInput } from "@alboompro/boom-components/data-entry/input/";
import styled from "styled-components";
import EditorLabel from "editor/components/EditorLabel";
import { debounce } from "shared/utils";
import { PropListItem } from "./styles";

const CustomPropListItem = styled(PropListItem)`
  user-select: none;
  > div {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  label {
    user-select: none;
  }
`;

class InstagramUser extends Component {
  state = {
    value: "",
    placeholder: ""
  };

  requestInfo = debounce(userName => {
    const {
      updaterFn,
      name,
      user: { domain, subdomain, pointed_domain }
    } = this.props;
    const baseUrl = pointed_domain ? `www.${domain}` : subdomain;

    updaterFn({ prop: "userLoading", value: true });
    axios
      .get(
        `https://${baseUrl}/instapi/?path=/v1/users/${userName}/media/recent/`
      )
      .then(({ data: { meta } }) => {
        if (meta.code === 200) {
          updaterFn([
            { prop: "userLoading", value: false },
            { prop: "hasError", value: false },
            { prop: name, value: userName }
          ]);
        } else {
          updaterFn([
            { prop: "userLoading", value: false },
            { prop: name, value: userName },
            { prop: "hasError", value: true }
          ]);
        }
      })
      .catch(err => {
        console.error(err);
      });
  }, 500);

  componentDidMount() {
    const { currentValue, placeholder, locale } = this.props;
    this.setState({
      value: currentValue,
      placeholder: !placeholder ? "" : placeholder[locale]
    });
  }

  handleUpdate = e => {
    this.setState({ value: e.target.value });
    this.requestInfo(e.target.value.replace("@", ""));
  };

  onKeyPress = e => {
    if (e.key === "Enter" || e.keyCode === 13) {
      this.handleUpdate(e);
    }
  };

  render() {
    const { label, name, locale, tooltip } = this.props;
    const { value, placeholder } = this.state;
    const tooltipText = (tooltip && tooltip[locale]) || null;

    return (
      <CustomPropListItem>
        <DefaultInput
          name={name}
          label={
            <EditorLabel tooltip={tooltipText}>{label[locale]}</EditorLabel>
          }
          inputStyle={{ fontSize: "12px", padding: "8px 10px" }}
          labelStyle={{
            fontSize: "12px",
            lineHeight: "normal",
            marginBottom: "3px"
          }}
          placeholder={placeholder}
          value={value}
          onChange={this.handleUpdate}
          onKeyPress={this.onKeyPress}
        />
      </CustomPropListItem>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps, {})(InstagramUser);
